<header-bar pageTitle="Companies" headingClass="fa-building"></header-bar>
   

<div class="container mt-5">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header text-white bg-primary">
                    <div class="row align-items-center">
                        <p class="h3 m-0 col">Add a company</p>
                        <div class="col text-right">
                            <button class="btn btn-outline-light btn-sm" (click)="addCompany(companyForm.value)" [disabled]="!companyForm.valid">Add Company <i class="fa fa-plus ml-2"></i></button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <form class="form" [formGroup]="companyForm" novalidate>
                         <div class="row">
                           <div class="col">
                                <div class="form-group mb-0">
                                    <input type="text" class="form-control" placeholder="Enter company name" formControlName="name" />
                                    <div *ngIf="companyForm.controls['name'].hasError('required') && companyForm.controls['name'].touched" class="alert alert-danger">Company name is required.</div>
                                    <div *ngIf="companyForm.controls['name'].hasError('pattern') && companyForm.controls['name'].touched" class="alert alert-danger">Company name is invalid.</div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="row" *ngIf="companies?.length > 0">
                        <div class="col">
                            <p class="mt-3"><strong>Existing matching companies</strong></p>
                            <ul class="mt-3">
                                <li class="" *ngFor="let company of companies">
                                    {{company.name}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
